import { render, staticRenderFns } from "./StatusObserver.vue?vue&type=template&id=6cbb23a2"
import script from "./StatusObserver.vue?vue&type=script&lang=js"
export * from "./StatusObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports